module.exports = __webpack_public_path__ + "static/img/tsgr.bbb7083.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/tsgr.png
// module id = m1CI
// module chunks = 0